<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 2</div>
    <h1 class="theme-heading__title">Социализация</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Знакомство с&nbsp;внешним&nbsp;миром</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-2/dog-1.webp" type="image/webp">
          <img src="/static/img/theme-2/dog-1.png" alt="Знакомство с&amp;nbsp;внешним&amp;nbsp;миром"/>
        </picture>
      </div>
      <p class="theme-point__text">Процесс социализации щенка необходимо начинать с&nbsp;раннего возраста&nbsp;&mdash; лучше всего <span class="accent">с&nbsp;трех месяцев</span>.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Постарайтесь, чтобы щенок <span class="accent">встречался по&nbsp;возможности с&nbsp;разными людьми, звуками и&nbsp;ситуациями</span>, чтобы он&nbsp;привык к&nbsp;разнообразию в&nbsp;своем окружении. Тогда он&nbsp;не&nbsp;будет проявлять страха в&nbsp;незнакомых ситуациях, когда вырастет.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">« Язык тела »</h2>
      <div class="theme-point__slider-block">
        <div class="swiper theme-point__slider theme-point__slider--shrank" data-theme-point-slider="data-theme-point-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-2/dog-slider-2.webp" type="image/webp">
                <img src="/static/img/theme-2/dog-slider-2.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-2/dog-slider-1.webp" type="image/webp">
                <img src="/static/img/theme-2/dog-slider-1.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-2/dog-slider-3.webp" type="image/webp">
                <img src="/static/img/theme-2/dog-slider-3.png" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-2/dog-slider-4.webp" type="image/webp">
                <img src="/static/img/theme-2/dog-slider-4.png" alt=""/>
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination="data-theme-point-slider-pagination"></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <p class="theme-point__text">Собаки обычно понимают всего несколько слов, но&nbsp;<span class="accent">очень чутко распознают позы и&nbsp;интонации человека</span>. Они считывают проявления ваших эмоций и&nbsp;даже намерений. Чтобы узнать больше об&nbsp;эмоциях собаки, пролистайте карусель.</p>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">Знакомство с&nbsp;другими животными в&nbsp;доме</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-2/dog-3.webp" type="image/webp">
          <img src="/static/img/theme-2/dog-3.png" alt="Знакомство с&amp;nbsp;другими животными в&amp;nbsp;доме"/>
        </picture>
      </div>
      <p class="theme-point__text">При появлении нового животного в&nbsp;доме собаке, которая уже живет там, часто бывает легче принять щенка или котенка, а&nbsp;не&nbsp;взрослого &laquo;конкурента&raquo; (если только между ними нет родственных связей).</p>
      <div class="theme-point__numbered">
        <div class="theme-point__numbered-title">Чтобы снизить риск осложнений при знакомстве двух животных, попробуйте сделать следующее:</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <p class="text">Организуйте <span class="accent">знакомство на&nbsp;нейтральной территории</span> (например, на&nbsp;улице, в&nbsp;месте, незнакомом обоим животным, или дома, но&nbsp;в&nbsp;комнате, куда уже имеющееся у&nbsp;вас животное заходит редко).</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <p class="text">Убедитесь, что у&nbsp;собаки <span class="accent">есть безопасное место, чтобы спрятаться</span>, если они сочтут ситуацию угрожающей.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <p class="text">Предоставьте каждому <span class="accent">животному отдельное место для сна, миску для корма, игрушки</span>, чтобы они чувствовали себя комфортно.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">4</span>
            <div>
              <p class="text">Позвольте животным знакомиться и<span class="accent">&nbsp;привыкать друг к&nbsp;другу постепенно</span>. Пусть вначале это происходит только под вашим присмотром.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button class="btn topic__btn"
  @click="$emit('goToQuiz')"
  onclick="sendEventYM(
     102182679,
     'quiz2_click_btn'
   );"
  >Закрепить знания</button>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue'
import { SliderManager } from '@/assets/js/script.js'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'LessonDogsTopic2',
  emits: ['goToQuiz'],
  setup() {
    let sliderManager = null

    onMounted(() => {
      sliderManager = new SliderManager()
      sliderManager.init()
    })

    onBeforeUnmount(() => {
      if (sliderManager) {
        sliderManager.destroy()
        sliderManager = null
      }
    })

    return {}
  }
}
</script>

<style scoped>
</style>
